var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChristmasGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.2,30.7H47.3c3.7-2.1,6-4.8,5.9-7.3c-0.1-2-1.6-3.5-4.1-4c-1.5-0.3-2.8,0-3.9,0.8c-1.6,1.3-2.6,3.7-3.1,5.9 c-0.5-2.3-1.5-4.7-3.1-5.9c-1.1-0.9-2.4-1.2-3.9-0.8c-2.5,0.6-4.1,2-4.1,4c-0.1,2.6,2.2,5.3,5.9,7.3H25.8c-1.9,0-3.5,1.6-3.5,3.5 v11.6c0,1.7,1.2,3.1,2.9,3.4c-0.2,0.5-0.4,1-0.4,1.6v11.6c0,1.9,1.6,3.5,3.5,3.5h28.1c1.9,0,3.5-1.6,3.5-3.5V50.7 c0-0.6-0.1-1.1-0.4-1.5c1.8-0.2,3.2-1.6,3.2-3.5V34.2C62.7,32.3,61.1,30.7,59.2,30.7z M46.4,21.7c0.5-0.4,1-0.5,1.6-0.5 c0.2,0,0.5,0,0.7,0.1c0.9,0.2,2.5,0.8,2.6,2.2c0.1,2-2.6,4.9-7.8,6.8C43.7,27.6,44.5,23.3,46.4,21.7z M32.9,23.4 c0.1-1.4,1.6-2,2.6-2.2c0.9-0.2,1.6,0,2.2,0.5c2,1.5,2.8,5.9,3,8.5C35.6,28.3,32.9,25.4,32.9,23.4z M24.3,45.7V34.2 c0-0.8,0.7-1.5,1.5-1.5h15.6v14.6H28.3h-2.5C25,47.2,24.3,46.6,24.3,45.7z M26.8,62.3V50.7c0-0.8,0.7-1.5,1.5-1.5h13.1v14.6H28.3 C27.5,63.8,26.8,63.1,26.8,62.3z M57.9,62.3c0,0.8-0.7,1.5-1.5,1.5H43.3V49.2h13.1c0.8,0,1.5,0.7,1.5,1.5V62.3z M60.7,45.7 c0,0.8-0.7,1.5-1.5,1.5h-2.8H43.3V32.7h15.9c0.8,0,1.5,0.7,1.5,1.5C60.7,34.2,60.7,45.7,60.7,45.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasGrey);
export default __webpack_public_path__ + "static/media/ChristmasGrey.b4ab60cbd6757259d71f1c600bba7e3f.svg";
export { ForwardRef as ReactComponent };